import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Status from './components/status';
import Badges from './components/badges';

import ProfileImage from '@fiverr/profile_image';
import '@fiverr/profile_image/dist/index.css';

import ReportUser from '@fiverr-private/report_user';
import '@fiverr-private/report_user/dist/index.css';

import ProfileLink from './components/profile_link';
import Oneliner from './components/oneliner';
import Buttons from './components/buttons';
import Pro from './components/pro';
import Stats from './components/stats';
import BlockUser from './components/block_user';
import Description from './components/description';
import translations from './translations.en.json';
import '@fiverr/i18n/singleton';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import classNames from 'classnames';

import './index.scss';

class SellerCard extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);

        this.state = {
            isOnline: false,
            isOnVacation: props.user.is_on_vacation,
            showBlockButton: false
        };

        const {
            allowEditing,
            viewingAsBuyer,
            isLoggedIn
        } = props;

        this.renderBlockButton = !allowEditing && !viewingAsBuyer && isLoggedIn;

        this.submitBlockTrigger = this.submitBlockTrigger.bind(this);
        this.toggleVacation = this.toggleVacation.bind(this);
    }

    componentDidMount() {
        if (document) {
            document.addEventListener('popup_close', () => {
                this.setState({
                    isOnVacation: false
                });
            });

            document.addEventListener('unblock_user', () => {
                this.setState({
                    showBlockButton: true
                });
            });

            document.addEventListener('out_of_office_on', () => {
                this.setState({
                    isOnVacation: true
                });
            });
        }

        const {
            user
        } = this.props;

        // this has a lot of checking to ensure this fails silently
        // when running in static or dev mode
        gofor(`/users/${user.username}/is_online`, {
            method: 'GET'
        }).then((response) => response.json())
            .then((response) => {
                if (response) {
                    this.setState({
                        isOnline: response.is_online === true
                    });
                }
            })
            .catch((err) => {
                throw err;
            });

        if (this.renderBlockButton) {
            gofor(`/users/${user.id}/interaction_blocking`)
                .then((response) => response.json())
                .then((response) => {
                    if (response) {
                        this.setState({
                            showBlockButton: response.show_block_button
                        });
                    }
                })
                .catch((err) => {
                    throw err;
                });
        }
    }

    get showReportUserButton() {
        const { shouldShowReportUser, isLoggedIn, allowEditing, viewingAsBuyer } = this.props;
        return shouldShowReportUser && isLoggedIn && !allowEditing && !viewingAsBuyer;
    }

    toggleVacation(e) {

        e.preventDefault();
        e.stopPropagation();

        const {
            user
        } = this.props;

        if (this.state.isOnVacation) {
            gofor(`/users/${user.username}/vacations`, {
                method: 'delete'
            }).then((response) => {
                if (response) {
                    const event = new CustomEvent('open_popup', { detail: false });
                    document.dispatchEvent(event);
                    this.setState({
                        isOnVacation: false
                    });
                }
            }).catch((err) => {
                throw err;
            });
        } else {
            const event = new CustomEvent('open_popup', { detail: true });
            document.dispatchEvent(event);
            this.setState({
                isOnVacation: true
            });
        }
    }

    submitBlockTrigger() {
        const event = new CustomEvent('block_user', { detail: false });
        document.dispatchEvent(event);

        this.setState({
            showBlockButton: false
        });
    }

    render() {

        const {
            showReportUserButton,
            renderBlockButton
        } = this;

        const {
            isOnline,
            isOnVacation,
            showBlockButton
        } = this.state;

        const {
            user,
            allowEditing,
            viewingAsBuyer,
            isMobileResponsive,
            isLoggedIn,
            showDescription,
            showCustomOrder,
            authToken,
            inWhitingContactButton,
            className,
            profileImageSize,
            hideProList
        } = this.props;

        let imageSize = profileImageSize;

        const neverLinkName = !showDescription, // when we're showing the description, we want to link the username as well
            allowEditingReal = allowEditing && !viewingAsBuyer, // if the user is in "buyer preview"-mode, editing is disabled
            showAmbassador = user.is_ambassador,
            showUserReportActions = showReportUserButton || showBlockButton,
            showNow = user.is_now_seller,
            proExp = user.is_pro_experience,
            showDescriptionReal = showDescription && user.description && user.description.length > 0,
            showPro = user.is_pro && user.pro_sub_categories && !!user.pro_sub_categories.length && !hideProList,
            classes = classNames('user-main-info', className, { 'pro-exp': proExp && user.is_pro }),
            userReportActionsClasses = classNames('user-report-actions', { 'with-divider': showReportUserButton && showBlockButton }),
            isWide = className && className.indexOf('seller-card-wide') !== -1;

        if (isWide && profileImageSize === undefined) {
            imageSize = 110;
        }

        return (

            <div className={classes}>
                <Status isOnline={isOnline} userId={user.id} isOnVacation={isOnVacation}/>

                {(showAmbassador || showNow) && !isWide &&
                    <Badges userName={user.username} showAmbassador={showAmbassador} showNow={showNow}/>
                }

                <div className="user-profile-info">
                    <ProfileImage user={user} allowEditing={allowEditingReal} authToken={authToken} fetchPolicyPath={'/attachments/policy'} uploadPhotoPath={'/profiles/update_photo'}
                        profileImageSize={imageSize}/>
                    <label className="user-profile-label">
                        <div className="username-line">
                            <ProfileLink userName={user.username} noLink={neverLinkName}/>
                            {(showAmbassador || showNow) && isWide &&
                                <Badges userName={user.username} showAmbassador={showAmbassador} showNow={showNow}/>
                            }
                        </div>
                        <Oneliner user={user} allowEditing={allowEditingReal} authToken={authToken}/>
                        {showUserReportActions &&
                            <div className={userReportActionsClasses}>
                                {showReportUserButton && <ReportUser user={user}/>}
                                {renderBlockButton && <BlockUser submitBlockTrigger={this.submitBlockTrigger} userId={user.id} userName={user.username} showBlockButton={showBlockButton}/>}
                            </div>
                        }
                        {isWide && <Buttons user={user} isMobileResponsive={isMobileResponsive} allowEditing={allowEditingReal}
                            viewingAsBuyer={viewingAsBuyer} isLoggedIn={isLoggedIn}
                            showCustomOrder={showCustomOrder} inWhitingContactButton={inWhitingContactButton}/>}
                    </label>
                </div>

                {!isWide && <Buttons user={user} isMobileResponsive={isMobileResponsive} allowEditing={allowEditingReal}
                    viewingAsBuyer={viewingAsBuyer} isLoggedIn={isLoggedIn} showCustomOrder={showCustomOrder}
                    inWhitingContactButton={inWhitingContactButton}/>}

                {showPro &&
                    <Pro proExp={proExp} proCategories={user.pro_sub_categories}/>
                }

                <div className="user-stats-desc">
                    <Stats user={user} allowEditing={allowEditingReal} isOnVacation={isOnVacation}
                        toggleVacation={this.toggleVacation}/>

                    {showDescriptionReal &&
                        <Description userDescription={user.description}/>}
                </div>
            </div>
        );
    }
}

SellerCard.propTypes = {
    user: PropTypes.object.isRequired,
    allowEditing: PropTypes.bool,
    viewingAsBuyer: PropTypes.bool,
    isMobileResponsive: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    showDescription: PropTypes.bool,
    showCustomOrder: PropTypes.bool,
    authToken: PropTypes.string,
    className: PropTypes.string,
    profileImageSize: PropTypes.number,
    shouldShowReportUser: PropTypes.bool
};

SellerCard.defaultProps = {
    user: {},
    allowEditing: false,
    viewingAsBuyer: false,
    isMobileResponsive: false,
    isLoggedIn: false,
    showDescription: true,
    showCustomOrder: true,
    shouldShowReportUser: false,
    authToken: ''
};

export default SellerCard;



// WEBPACK FOOTER //
// ./src/SellerCard.js